module.exports = __webpack_public_path__ + "static/media/iconWhite.bce62789.png";